import { COUNTRY_CODE_OPTIONS } from '@/utils/countries';
import { selectOptions } from '@/utils/select-options';

export {
  isUnitedStates,
  isZipCodeIgnored,
  US_STATE_SELECT_OPTIONS,
  COUNTRY_PLACEHOLDER,
  US_STATE_PLACEHOLDER,
} from '@/utils/address-form';

// Source the picker from the same list `countryToCode`/`codeToCountry` look up, so every selected
// country name round-trips to an ISO code for address validation (the stored value stays the full
// country name for backward compatibility with saved account addresses).
export const COUNTRY_SELECT_OPTIONS = selectOptions(COUNTRY_CODE_OPTIONS.map((option) => option.label));
